export default __webpack_public_path__ + "static/media/ratings-review.e25e676b.png";